/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2019. All Rights Reserved.
 #*
 #*===================================================================
 */

import { PRICE_CONFIGURATION_TYPE, PriceConfigDescription, PRICE_CONFIGURATION_CATEGORY } from './price-config.model';
import { Plan } from './plan.model';
import { GlobalPriceConfigurationPriceType } from './global-price-configuration-price-type.model';
import { CompanyTypesEnum } from '@truckstop-tms/zuum-lib';

export enum GLOBAL_PRICE_CONFIGURATION_CLIENT_TYPE {
  BROKER_SAAS = 'BROKER_SAAS',
  SHIPPER_SAAS = 'SHIPPER_SAAS',
  CARRIER_SAAS = 'CARRIER_SAAS',
}

export interface GlobalPriceConfiguration {
  id?: number;
  clientType: GLOBAL_PRICE_CONFIGURATION_CLIENT_TYPE;
  category: PRICE_CONFIGURATION_CATEGORY | null;
  plan?: Plan;
  originalValue: string;
  updatedAt?: Date;
  updatedBy?: string;
  isVisible?: boolean;
  priceConfigDescription: PriceConfigDescription;
  priceConfigDescriptionId: number;
  globalPriceConfigurationPriceTypes: GlobalPriceConfigurationPriceType[];

  // front-end
  group: string;
  disabled?: boolean;
  disableToggle?: boolean;
  tooltip?: string;
  groupTitle?: PRICE_CONFIGURATION_TYPE;
  adjustedValue: string;
  selected: boolean;
  additionalText: string;
  innerTab: boolean;
  expandible?: boolean;
  expanded?: boolean;
}

export const mapCompanyTypeToGlobalConfigClientType = {
  [CompanyTypesEnum.Broker]: GLOBAL_PRICE_CONFIGURATION_CLIENT_TYPE.BROKER_SAAS,
  [CompanyTypesEnum.Shipper]: GLOBAL_PRICE_CONFIGURATION_CLIENT_TYPE.SHIPPER_SAAS,
  [CompanyTypesEnum.Carrier]: GLOBAL_PRICE_CONFIGURATION_CLIENT_TYPE.CARRIER_SAAS,
};
